// components/ContactMe.jsx
import React from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { background } from "../../theme/colors";
import { SiLeetcode } from "react-icons/si";
import { IoLogoInstagram } from "react-icons/io5";

export default function ContactMe() {
  const theme = useTheme();

  const socialButtons = [
    {
      Icon: MailOutlineIcon,
      href: "mailto:pratikshinde7262@gmail.com?subject=Hiring%20Inquiry&body=Hi%20there!",
      label: "Email",
    },
    {
      Icon: GitHubIcon,
      href: "https://github.com/pratik7262",
      label: "GitHub",
    },
    {
      Icon: LinkedInIcon,
      href: "https://www.linkedin.com/in/pratikshinde7262/",
      label: "LinkedIn",
    },
    {
      Icon: SiLeetcode,
      href: "https://leetcode.com/u/pratik_7262/",
      label: "LeetCode",
    },
    {
      Icon: IoLogoInstagram,
      href: "https://instagram.com/pratik_72.62",
      label: "Instagram",
    },
  ];

  return (
    <Box
      id="contact"
      sx={{
        pt: { xs: 6, md: 10 },
        pb: 1,
        // position: "relative",
        // background: `linear-gradient(-45deg, ${theme.palette.background.default}, ${theme.palette.background.paper}, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
        // backgroundSize: "400% 400%",
        // animation: `${gradientMove} 15s ease infinite`,
      }}
    >
      <Grid container justifyContent="center" sx={{ px: 2 }}>
        <Grid item xs={12} md={8}>
          <Box
            sx={{
              background: alpha(background, 0.7),
              backdropFilter: "blur(20px)",
              borderRadius: 3,
              boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
              border: `1px solid ${alpha(theme.palette.text.secondary, 0.1)}`,
              p: { xs: 3, md: 5 },
              //   transform: "translateY(0px)",
              transition: "transform 0.3s ease",
              //   "&:hover": {
              //     transform: "translateY(-6px)",
              //   },
            }}
          >
            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                mb: 2,
                textAlign: "center",
              }}
            >
              Let&apos;s Connect
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                mb: 4,
                textAlign: "center",
                lineHeight: 1.7,
              }}
            >
              Got a project, idea, or just want to say hi? Reach
              out through my social media links below — I’ll get back to you
              soon.
            </Typography>

            {/* Social Icons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                mb: 4,
              }}
            >
              {socialButtons.map(({ Icon, href, label }, i) => (
                <IconButton
                  key={i}
                  href={href}
                  target="_blank"
                  aria-label={label}
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.06),
                    color: theme.palette.primary.main,
                    transition: "transform 0.18s ease, background-color 0.18s",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      backgroundColor: alpha(theme.palette.primary.main, 0.14),
                    },
                  }}
                >
                  <Icon />
                </IconButton>
              ))}
            </Box>

            {/* Form */}
            {/* <Box component="form" onSubmit={(e) => e.preventDefault()}>
              <TextField
                fullWidth
                label="Your name"
                variant="outlined"
                sx={textFieldSx}
              />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                sx={textFieldSx}
              />
              <TextField
                fullWidth
                label="Message"
                multiline
                rows={5}
                variant="outlined"
                sx={textFieldSx}
              />
              <Box sx={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.text.primary,
                    borderRadius: "999px",
                    px: 4,
                    py: 1.25,
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                >
                  Send Message
                </Button>
              </Box>
            </Box> */}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
